<template>
  <nav class="menu-container">
    <h3><font color="#A192B2">12号线</font></h3>
    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
  </nav>
</template>

<script>
import Icon from "@/components/Icon";
export default {
  components: {
    Icon,
  },
  data() {
    return {
      items: [
        {
          name: "zuopaotaidong",
          title: "左炮台东",
          // icon: "chat",
          exact: true,
        },
        {
          name: "taiziwan",
          title: "太子湾",
          // icon: "chat",
          exact: true,
        },
        {
          // 海上世界分为两个站点信息，一是2号线的，haishangshijie。二是12号线的，haishangshijie2.
          name: "haishangshijie2",
          title: "海上世界",
          // icon: "chat",
          exact: true,
        },
        {
          name: "huaguoshan",
          title: "花果山",
          // icon: "chat",
          exact: true,
        },
        {
          name: "sihai",
          title: "四海",
          // icon: "chat",
          exact: true,
        },
        {
          name: "nanyou",
          title: "南油",
          // icon: "chat",
          exact: true,
        },
        {
          name: "nanguang",
          title: "南光",
          // icon: "chat",
          exact: true,
        },
        {
          name: "nanshan",
          title: "南山",
          // icon: "chat",
          exact: true,
        },
        {
          name: "taoyuan",
          title: "桃园",
          // icon: "chat",
          exact: true,
        },
        {
          name: "nantougucheng",
          title: "南头古城",
          // icon: "chat",
          exact: true,
        },
        {
          name: "zhongshangongyuan",
          title: "中山公园",
          // icon: "chat",
          exact: true,
        },
        {
          name: "tonglenan",
          title: "同乐南",
          // icon: "chat",
          exact: true,
        },
        {
          name: "xinangongyuan",
          title: "新安公园",
          // icon: "chat",
          exact: true,
        },
        {
          // 灵芝站点信息有2个，一个在5号线lingzhi.另一个在12号线lingzhi2.
          name: "lingzhi2",
          title: "灵芝",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shangchuan",
          title: "上川",
          // icon: "chat",
          exact: true,
        },
        {
          name: "liutang",
          title: "流塘",
          // icon: "chat",
          exact: true,
        },
        {
          name: "baoankeyunzhan",
          title: "宝安客运站",
          // icon: "chat",
          exact: true,
        },
        {
          name: "baotianyilu",
          title: "宝田一路",
          // icon: "chat",
          exact: true,
        },
        {
          name: "pingluanshan",
          title: "平峦山",
          // icon: "chat",
          exact: true,
        },
        {
          name: "xixiangtaoyuan",
          title: "西乡桃源",
          // icon: "chat",
          exact: true,
        },
        {
          name: "zhongwunan",
          title: "钟屋南",
          // icon: "chat",
          exact: true,
        },
        {
          name: "huangtian",
          title: "黄田",
          // icon: "chat",
          exact: true,
        },
        {
          name: "xingwei",
          title: "兴围",
          // icon: "chat",
          exact: true,
        },
        {
          name: "jichangdong",
          title: "机场东",
          // icon: "chat",
          exact: true,
        },
        {
          name: "fuwei",
          title: "福围",
          // icon: "chat",
          exact: true,
        },
        {
          name: "huaide",
          title: "怀德",
          // icon: "chat",
          exact: true,
        },
        {
          name: "fuyong",
          title: "福永",
          // icon: "chat",
          exact: true,
        },
        {
          name: "qiaotouxi",
          title: "桥头西",
          // icon: "chat",
          exact: true,
        },
        {
          name: "fuhaixi",
          title: "福海西",
          // icon: "chat",
          exact: true,
        },
        {
          name: "guozhan",
          title: "国展",
          // icon: "chat",
          exact: true,
        },
        {
          name: "guozhanbei",
          title: "国展北",
          // icon: "chat",
          exact: true,
        },
        {
          name: "haishangtianyuannan",
          title: "海上田园南",
          // icon: "chat",
          exact: true,
        },
        {
          name: "haishangtianyuandong",
          title: "海上田园东",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(67, 47, 221);
    }
  }
}
</style>





<!-- <template>
  <div>
    <h3>
        首页<br><br>
深圳地铁1号线 途经站点 共30站<br><br>
注：高峰期发车间隔为4分钟，平峰期为6分钟<br><br>

罗湖站-国贸站-老街站-大剧院站-科学馆站-华强路站-岗厦站-会展中心站-购物公园站-香蜜湖站-车公庙站-竹子林站-侨城东站-华侨城站-世界之窗站-白石洲站-高新园站-深大站-桃园站-大新站-鲤鱼门站-前海湾站-新安站-宝安中心站- 宝体站-坪洲站-西乡站-固戍站-后瑞站-机场东站
    </h3>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style> -->